module.exports = __webpack_public_path__ + "static/media/heist_background.e94d45cf.jpg";